import type { Tenant } from "../Tenant.js";
import { getReferencePath } from "./getReferencePath.js";

export function getClientsPath(tenant: Tenant): string {
	return getReferencePath(tenant);
}
